import classes from './drawer.module.css'

const Drawer = {
  classNames: {
    body: classes.body,
    content: classes.content,
    header: classes.header,
    title: classes.title,
  },
}

export default Drawer
